/**
 * Role home for the profile menu and post-login routing.
 * Uses routes that already exist in the app.
 */
export const ROLE_DASHBOARDS = {
  patient: '/patient-dashboard',
  clinic: '/site-portal',
  site_clinic: '/site-portal',
  sponsor: '/sponsor-dashboard',
  sponsor_cro: '/sponsor-dashboard',
  investor: '/investor-dashboard',
  investor_demo: '/investor-dashboard',
  fellow: '/fellowship-portal',
  clincore: '/fellowship-portal',
  staff: '/administrator-portal',
  superadmin: '/administrator-portal',
  superuser: '/administrator-portal',
  super_admin: '/administrator-portal',
  executive: '/administrator-portal',
  management: '/administrator-portal',
  operations: '/administrator-portal',
  sales: '/administrator-portal',
  admin: '/administrator-portal',
  nurse: '/clinician-review-dashboard',
  nurse_reviewer: '/clinician-review-dashboard',
  coordinator: '/clinician-review-dashboard',
  provider_clinician: '/clinician-review-dashboard',
  clinician_reviewer: '/clinician-review-dashboard',
};

export function dashboardPathForRole(role) {
  const key = String(role || '').trim().toLowerCase();
  if (!key) return '/patient-dashboard';
  return ROLE_DASHBOARDS[key] || '/administrator-portal';
}

/** Sign-in page for a known role. Unknown and patient roles use the patient login. */
export function loginPathForRole(role) {
  const key = String(role || '').trim().toLowerCase();
  if (key === 'clinic' || key === 'site' || key === 'site_clinic') return '/clinic-login';
  if (key === 'sponsor' || key === 'sponsor_cro') return '/sponsor-login';
  if (key === 'clincore' || key === 'fellow') return '/clincore-login';
  if (!key || key === 'patient') return '/patient-login';
  return '/staff-login';
}

/** Signed-out /dashboard destination, preserving return so a successful sign-in can finish the hop. */
export function dashboardLoginPath(role) {
  const params = new URLSearchParams();
  params.set('next', '/dashboard');
  return `${loginPathForRole(role)}?${params.toString()}`;
}

export function dashboardLabelForRole(role) {
  const key = String(role || '').trim().toLowerCase();
  if (key === 'patient') return 'Patient dashboard';
  if (key === 'clinic' || key === 'site_clinic') return 'Site dashboard';
  if (key === 'sponsor' || key === 'sponsor_cro') return 'Sponsor dashboard';
  if (key === 'investor' || key === 'investor_demo') return 'Investor dashboard';
  if (key === 'fellow' || key === 'clincore') return 'Fellowship dashboard';
  if (['nurse', 'nurse_reviewer', 'coordinator', 'provider_clinician', 'clinician_reviewer'].includes(key)) {
    return 'Clinician dashboard';
  }
  return 'Staff dashboard';
}
